import Vue from 'vue'
import './pollyfills'

import Vuex from 'vuex'
import axios from 'axios'

import VueRouter from 'vue-router'
// import VueNotify from 'vue-notifyjs'

import ApolloClient from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'

import customFetch from './customFetch';
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import App from './App.vue'
import wysiwyg from 'vue-wysiwyg'

import { DataTables, DataTablesServer } from 'vue-data-tables'
import store from './store'
// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
// Tuto menu

import VueCurrencyFilter from 'vue-currency-filter'
import './filters'
// router setup
import routes from './routes/routes'
// Dev Tools
import VueJsonContent from 'vue-json-content'

// library imports
import lodash from 'lodash'

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import '../node_modules/vue-wysiwyg/dist/vueWysiwyg.css'
import '../node_modules/vue-pell-editor/dist/vue-pell-editor.css'

import sidebarLinks from './sidebarLinks'
import tutorLinks from './tutorLinks'
import VueTheMask from 'vue-the-mask'
//Calendar


// Charts
import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Charts from 'fusioncharts/fusioncharts.charts'
import TimeSeries from 'fusioncharts/fusioncharts.timeseries'

//import the theme
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'
import ZuneTheme from 'fusioncharts/themes/fusioncharts.theme.zune'


Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

Vue.use(VueJsonContent)
Vue.use(VueTheMask)
Vue.use(Vuex)
// plugin setup
Vue.use(VueRouter)
Vue.use(ElementUI, { locale })
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
// Vue.use(VueNotify, {timeout: 5000})
Vue.use(SideBar, {sidebarLinks: sidebarLinks, tutorLinks: tutorLinks})
// Vue.use(VeeValidate)
Vue.use(DataTables)
Vue.use(DataTablesServer)
Vue.use(wysiwyg, {})
// locale.use(lang)
Vue.use(require('vue-moment'))
Vue.use(VueCurrencyFilter, {
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
})
Vue.use(VueApollo)

// register VueFusionCharts component
Vue.use(VueFusionCharts, FusionCharts, Charts, FusionTheme, ZuneTheme, TimeSeries)
// configure router
export const router = new VueRouter({
  routes, // short for routes: routes
  // mode: 'history',
  linkActiveClass: 'active'
})
const setAuthorizationLink = setContext((request, previousContext) => ({
  headers: {authorization: window.localStorage.getItem('jwt_token')}
}))
const getHeaders = () => {
  const headers = {}
  const token = window.localStorage.getItem('jwt_token')
  if (token) {
    console.log(token)
     // headers["x-hasura-admin-secret"]= "101tefl"
    headers.authorization = `Bearer ${token}`
    headers['access-control-allow-credentials'] = true
  }
  return headers
}
 // Create an http link:
const link = new HttpLink({
 uri:process.env.HASURA_URL,
  fetch:customFetch,
  headers: getHeaders()
})
const partnerlink = new HttpLink({
  uri:'https://graphql.online-tefl-course.com/v1/graphql',
   fetch:customFetch,
   headers: {"x-hasura-admin-secret":process.env.PARTNER_KEY}
 })
 const partnerClient  = new ApolloClient({
  link:partnerlink,
  cache: new InMemoryCache({
   appTypename: true
 })
   
 });
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('jwt_token')
  if (token) {
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ''
      }
    }
  } else {
    router.push('/login')
  }
})

const client = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache({
    appTypename: true
  })
})



const apolloProvider = new VueApollo({
  defaultClient: client,
  clients:{
    client,
    partnerClient
  },
  defaultOptions: {
    // See 'apollo' definition
    // For example: default query options
    $query: {
      loadingKey: 'loading'

    }
  },
  errorHandler (error) {
    console.log('Global error handler', error.networkError.statusCode);
    
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  apolloProvider,
  axios,
  router,

  render: h => h(App)

})

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}



// WEBPACK FOOTER //
// ./src/main.js